import React, { useEffect, useState } from 'react'

import { Image } from 'react-konva'

import tree from '../FurnitureCreator/icons/tree.svg'
import bush from '../FurnitureCreator/icons/bush.svg'
import plant from '../FurnitureCreator/icons/plant.svg'
import bar from '../FurnitureCreator/icons/bar.svg'
import exit from '../FurnitureCreator/icons/exit.svg'
import wc from '../FurnitureCreator/icons/wc.svg'
import sofa1 from '../FurnitureCreator/icons/sofa1x1.svg'
import sofa2 from '../FurnitureCreator/icons/sofa.svg'
import sofa3 from '../FurnitureCreator/icons/sofa3x1.svg'
import chair from '../FurnitureCreator/icons/chair.svg'
import barChair from '../FurnitureCreator/icons/barChair.svg'
import doorLeft from '../FurnitureCreator/icons/doorLeft.svg'
import doorRight from '../FurnitureCreator/icons/doorRight.svg'
import doubleDoors from '../FurnitureCreator/icons/doubleDoors.svg'

const ImageElement = ({ shapeProps: { width, height, objectKind, shape } }) => {
	const [image, setImage] = useState(null)
	let imageObj = new window.Image()

	const M = width < height ? width : height

	let imageHeight
	let imageWidth
	switch (objectKind) {
		case 'tree':
		case 'bush':
		case 'plant':
			imageHeight = width
			imageWidth = width
			break
		case 'sofa':
		case 'doorLeft':
		case 'doorRight':
		case 'doubleDoors':
			imageHeight = height
			imageWidth = width
			break
		case 'bar':
		case 'wc':
			imageHeight = M / 1.5
			imageWidth = M / 1.5
			break
		case 'exit':
			imageHeight = M / 2
			imageWidth = M / 2
			break
		case 'chair':
		case 'barChair':
			imageHeight = M / 1.3
			imageWidth = M / 1.3
			break
		default:
			imageHeight = 30
			imageWidth = 30
	}

	const imageOffsetX = (function () {
		switch (true) {
			case shape === 'round':
				return width / 2
			case objectKind === 'sofa':
			case objectKind === 'doorLeft':
			case objectKind === 'doorRight':
			case objectKind === 'doubleDoors':
				return 0
			default:
				return -(width - imageWidth) / 2
		}
	  }())

	  const imageOffsetY = (function () {
		switch (true) {
			case shape === 'round':
				return height / 2
			case objectKind === 'sofa':
			case objectKind === 'doorLeft':
			case objectKind === 'doorRight':
			case objectKind === 'doubleDoors':
				return 0
			default:
				return -(height - imageWidth) / 2
		}
	  }())

	  const getSofaImage = () => {
		const value = width / height
		switch (true) {
			case value >= 3:
				return sofa3
			case value >= 1.3:
				return sofa2
			default:
				return sofa1
		}
	  }

	useEffect(() => {
		let src = ''
		switch(objectKind) {
			case 'tree': src = tree; break
			case 'bush': src = bush; break
			case 'plant': src = plant; break
			case 'bar': src = bar; break
			case 'exit': src = exit; break
			case 'wc': src = wc; break
			case 'sofa': src = getSofaImage(); break
			case 'chair': src = chair; break
			case 'barChair': src = barChair; break
			case 'doorLeft': src = doorLeft; break
			case 'doorRight': src = doorRight; break
			case 'doubleDoors': src = doubleDoors; break
			default: src = ''
		}

		imageObj.src = src

		if (src) {
			setImage(imageObj)
		}
	}, [width, height])

	return (<Image
		image={image}
		height={imageHeight}
		width={imageWidth}
		offsetX={imageOffsetX}
		offsetY={imageOffsetY}
	/>)
}

export default ImageElement
